import { Transition } from 'common/interfaces'
import { conditionsMap } from 'utils/conditions'
import { MustacheCustomRender } from 'utils/hook'
import { CheckFunction } from 'utils/interfaces'

export const nextStep = (
  transitions: Transition[],
  render: MustacheCustomRender
): string | null => {
  const sorted = transitions.sort((a, b) => b.order - a.order)

  if (sorted.length === 0) {
    return null
  }

  for (const transition of sorted) {
    const { conditions, destination } = transition
    let completed = true

    Object.entries(conditions).forEach(([fieldName, conditionObject]) => {
      for (const conditionName in conditionObject) {
        const checkFunc = conditionsMap[conditionName as CheckFunction]
        const target = render(fieldName)
        const value = conditionObject[conditionName as CheckFunction]

        // @ts-expect-error Type error
        if (!checkFunc(target, value)) {
          completed = false
        }
      }
    })

    if (completed) {
      return destination
    }
  }

  return sorted[0].destination
}
